import React, { Component } from 'react';
import {
    Map, TileLayer, ZoomControl, GeoJSON, Marker, Polygon, FeatureGroup, Popup, LayersControl, Circle
} from 'react-leaflet';
import L from 'leaflet';
import IconGenerator from '../IconComponent/IconComponent';
import PopupComponent from '../PopupComponent/PopupComponent';

const text = L.divIcon({ html: 'Your HTML text here' });
class MarkerComponent extends Component {
    constructor(props) {
        super(props);
        //this.state = {  }
    }


    render() {
        const { coordinates, markerIcon, size } = this.props;
        return (
            <Marker position={coordinates} icon={IconGenerator(markerIcon, size)}>
                <PopupComponent {...this.props} />
            </Marker>
        );
    }
}

export default MarkerComponent;
